import { useSelector } from "react-redux";
import { gettoken, getvoucher } from "../../../../Localstorage/Store";
import Accountprice from "../../../../utils/Accountprice";
import { BsInfoCircle } from 'react-icons/bs';
import axios from "axios";
import { useRef, useState } from "react";
const VoucherSection = ({ voucherInfo, cartInfo, setshowbtn }) => {
  const tokenvalue = gettoken();
  const localvouhcer = getvoucher();
  const [voucherdesc, setvoucherdesc] = useState([]);
  const {bgColor, textColor } = useSelector((state) => state.theam);
  const [vouchervalue, setvouchervalue] = useState("");
  const [vouchererror, setvouchererror] = useState("");
  const closeref = useRef(null);
  const openalert = useRef(null);


  const alertb = () => {
    openalert.current.click();
    setTimeout(() => {
      setvouchererror("");
      closeref.current.click();
    }, 3000);
  };

  const applyvoucher = async (vouchercode) => {
    setshowbtn(false)
    if (!vouchercode || vouchercode === "") return;
    try {
      const formdata = new FormData();
      formdata.append("vouchercode", vouchercode);
      const config = {headers: {Authorization: `Bearer ${tokenvalue.access}`}};
      let url = `${process.env.REACT_APP_API_URL}cartapi/assign-voucher/`;
      const response = await axios.post(url, formdata, config);
      if (response.data == "voucher is not clubable") {
        setvouchererror("voucher is not clubable");
        alertb()
      }
      if (!response.data.code) {
        setvouchererror(response.data);
      } else {
        setvouchererror("");
      }
      setvouchervalue("");
      cartInfo.cartRefetch();
    } catch (error) {
      console.log("sdfghdddddddddddd", error)
      if (error.response.data.non_field_errors) {
        setvouchererror(error.response.data.non_field_errors[0]);
        alertb()
      }
      if (error.response.data.msg) {
        setvouchererror(error.response.data.msg);
        alertb()
        return
      }
      if (error.response.data) {
        setvouchererror(error.response.data);
        alertb()
      }
    }
  };

  const removevoucher = async (codename) => {
    try {
      const formdata = new FormData();
      formdata.append("vouchercode", codename);
      const config = { headers: { Authorization: `Bearer ${tokenvalue.access}` } };
      let url = `${process.env.REACT_APP_API_URL}cartapi/remove-voucher/`;
      const response = await axios.post(url, formdata, config);
      cartInfo.cartRefetch();
    } catch (error) {
      console.log("error", error.response.data);
    }
  };

  const funvoucherdesc = (item) => {
    const validJsonString = item.replace(/'/g, '"');
    setvoucherdesc(JSON.parse(validJsonString))
  }

  return (
    <div
      style={{
        backgroundColor: "white",
        padding: "0px 6px",
        marginBottom: "8px",
      }}
    >
      <table className="table bg-white mt-3">
        <tbody>
          <tr className="" style={{ borderColor: "#333" }}>
            <td
              style={{
                fontWeight: "700",
                display: "flex",
                gap: "19px",
                alignItems: "center",
                flexWrap: "wrap",
              }}
              className="titlesizes"
            >
              <span>
                Redeem Voucher(s)
              </span>
              <div style={{ display: "flex", gap: 4 }}>
                <span
                  style={{
                    fontWeight: 700,
                    color: "#230BB3",
                  }}
                >
                  <input
                    type="text"
                    value={vouchervalue}
                    style={{ borderRadius: "0px" }}
                    className="form-control applypay"
                    placeholder="Enter Your Voucher Code"
                    onChange={(e) => {
                      setvouchervalue(e.target.value);
                    }}
                  />
                </span>
                <button
                  className="btn"
                  style={{
                    fontWeight: 500,
                    backgroundColor: `#${bgColor}`,
                    color: "white",
                    borderRadius: "0px",
                    fontSize: 12,
                    height: "fit-content",
                    padding: "7px 8px",
                  }}
                  onClick={() => {
                    applyvoucher(vouchervalue);
                  }}
                >
                  Apply
                </button>
              </div>
              <span
                className="carttotalhere"
                style={{
                  color: "",
                  fontSize: "12px",
                  fontWeight: "500",
                }}
              >
                Voucher(s) Applied:{" "}
                <span
                  style={{
                    border: "1px solid #ced4da",
                    padding: "2px 5px",
                  }}
                >
                  {voucherInfo.voucherlist.length}
                </span>{" "}
                : Value:{" "}
                <span
                  style={{
                    border: "1px solid #ced4da",
                    padding: "2px 5px",
                  }}
                >

                  {Accountprice(voucherInfo.total_Voucher_Amount)}
                </span>
              </span>
            </td>
          </tr>
        </tbody>
      </table>

      <div
        className="newscrollerbar"
        style={{ width: "100%" }}
      >
        <table
          className="table-responsive bg-white mt-3"
          style={{ width: "100%" }}
        >
          <tbody>
            <>
              <tr>
                <th
                  style={{
                    textAlign: "center",
                    fontSize: "12px",
                  }}
                >
                  S.NO
                </th>
                <th
                  style={{
                    textWrap: "nowrap",
                    fontSize: "12px",
                    width: "18%",
                  }}
                >
                  Voucher Code
                </th>
                <th
                  style={{
                    textWrap: "nowrap",
                    fontSize: "12px",
                    width: "19%",
                  }}
                  className="px-lg-0 px-2"
                >
                  Voucher Type
                </th>
                <th
                  style={{
                    textWrap: "nowrap",
                    fontSize: "12px",
                    width: "18%",
                  }}
                  className="px-lg-0 px-2"
                >
                  GST
                </th>
                <th
                  style={{
                    textWrap: "nowrap",
                    fontSize: "12px",
                    width: "18%",
                  }}
                  className="px-lg-0 px-2"
                >
                  Shipping
                </th>
                <th
                  style={{
                    textWrap: "nowrap",
                    fontSize: "12px",
                  }}
                  className="px-lg-0 px-2"
                >
                  Value
                </th>
                <th></th>
              </tr>

              {

                voucherInfo.voucherlist.map((item, index) => (
                  <tr
                    style={{
                      display:
                        tokenvalue.msg == "Voucher login"
                          ? item.code == localvouhcer
                            ? ""
                            : "none"
                          : "none",
                    }}
                  >
                    <td>
                      <span
                        style={{
                          display: "flex",
                          width: "100%",
                          justifyContent: "center",
                        }}
                      >
                        {1}
                      </span>
                    </td>
                    <td>
                      <div>
                        <div
                          className="firstrow  justify-content-between mt-1 py-1 align-items-center"
                          style={{
                            display:
                              tokenvalue.msg ==
                                "Voucher login"
                                ? item.code == localvouhcer
                                  ? "flex"
                                  : "none"
                                : "none",
                          }}
                        >
                          <div
                            className="firstcontianer d-flex align-items-center"
                            style={{ gap: 4 }}
                          >
                            <div className="containerimg">
                              <img
                                src="/images/carticon.png"
                                style={{ width: "15px" }}
                                alt={404}
                              />
                            </div>
                            <div
                              style={{
                                display: "flex",
                                justifyContent:
                                  "space-between",
                                gap: "4px",
                                alignItems: "baseline",
                                minWidth: "192px",
                              }}
                            >
                              <p
                                className="m-0"
                                style={{
                                  fontWeight: 400,
                                  fontSize: "12px",
                                }}
                              >
                                {item.code}

                                <span
                                  onClick={() => {
                                    funvoucherdesc(
                                      item.description
                                    );
                                  }}
                                  className="icon"
                                  data-bs-toggle="modal"
                                  data-bs-target="#voucherdesc"
                                >
                                  {" "}
                                  <BsInfoCircle />
                                </span>

                              </p>
                            </div>
                          </div>

                        </div>
                      </div>
                    </td>
                    <td style={{ fontSize: "12px" }}>
                      {item.clubable
                        ? "Clubbable"
                        : "Nonclubbable"}
                    </td>

                    <td style={{ fontSize: "12px" }}>
                      {item.voucher_type ==
                        "Gift Voucher - Exclusive" ||
                        item.voucher_type ==
                        "Shopping Voucher - Exclusive"
                        ? "Payable"
                        : "Included"}
                    </td>
                    <td style={{ fontSize: "12px" }}>
                      {" "}
                      {item.shipping_incl == false
                        ? "Payable"
                        : item.voucher_type ==
                          "Gift Voucher - Exclusive" || item.voucher_type ==
                          "Gift Voucher - Inclusive" ? "Payable" : "Included"}{" "}
                    </td>
                    <td style={{ fontSize: "12px" }}>
                      {" "}
                      {Accountprice(item.offer)}
                    </td>
                    <td>
                      <div></div>
                    </td>
                  </tr>
                ))}

              {voucherInfo.voucher_list_without_deafultVoucher[0]?.code
                ? voucherInfo.voucher_list_without_deafultVoucher.map((item, index) => (
                  <tr
                    style={{
                      display:
                        tokenvalue.msg == "Voucher login"
                          ? item.code == localvouhcer
                            ? "none"
                            : ""
                          : "",
                    }}
                  >
                    <td>
                      <span
                        style={{
                          display: "flex",
                          width: "100%",
                          justifyContent: "center",
                        }}
                      >
                        {index + 2}
                      </span>
                    </td>
                    <td>
                      <div>
                        <div
                          className="firstrow  py-1 justify-content-between  align-items-center"
                          style={{
                            display:
                              tokenvalue.msg ==
                                "Voucher login"
                                ? item.code == localvouhcer
                                  ? "none"
                                  : "flex"
                                : "flex",
                          }}
                        >
                          <div
                            className="firstcontianer d-flex align-items-start"
                            style={{ gap: 4 }}
                          >
                            <div className="containerimg">
                              <img
                                src="/images/carticon.png"
                                style={{ width: "15px" }}
                                alt={404}
                              />
                            </div>
                            <div
                              style={{
                                display: "flex",
                                justifyContent:
                                  "space-between",
                                gap: "4px",
                                alignItems: "baseline",
                                minWidth: "192px",
                              }}
                            >
                              <p
                                className="m-0"
                                style={{
                                  fontWeight: 400,
                                  fontSize: "12px",
                                  position: "relative",
                                  top: "3px",
                                }}
                              >
                                {item.code}


                                <span
                                  onClick={() => {
                                    funvoucherdesc(
                                      item.description
                                    );
                                  }}
                                  className="icon"
                                  data-bs-toggle="modal"
                                  data-bs-target="#voucherdesc"
                                >
                                  {" "}
                                  <BsInfoCircle />
                                </span>
                              </p>
                            </div>
                          </div>

                        </div>{" "}
                      </div>
                    </td>

                    <td style={{ fontSize: "12px" }}>
                      {item.clubable
                        ? "Clubbable"
                        : "Nonclubbable"}
                    </td>

                    <td style={{ fontSize: "12px" }}>
                      {item.voucher_type ==
                        "Gift Voucher - Exclusive" ||
                        item.voucher_type ==
                        "Shopping Voucher - Exclusive"
                        ? "Payable"
                        : "Included"}
                    </td>
                    <td style={{ fontSize: "12px" }}>
                      {" "}

                      {item.shipping_incl == false
                        ? "Payable"
                        : item.voucher_type ==
                          "Gift Voucher - Exclusive" || item.voucher_type ==
                          "Gift Voucher - Inclusive" ? "Payable" : "Included"}
                    </td>
                    <td style={{ fontSize: "12px" }}>
                      {" "}
                      {Accountprice(item.offer)}

                    </td>
                    <td>
                      <span
                        style={{
                          color: "red",
                          cursor: "pointer",
                          display: "inline-block",
                          position: "relative",
                          left: "5px",
                        }}
                        onClick={() => {
                          removevoucher(item.code);
                        }}
                      >
                        <img
                          src="/images/delete.png"
                          style={{ width: "14px" }}
                          alt={404}
                        />
                      </span>
                    </td>
                  </tr>
                ))
                : ""}
            </>
          </tbody>
        </table>
      </div>









      <div
        className="modal fade"
        id="voucherdesc"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered ">
          <div className="modal-content">
            <div
              class="modal-header"
              style={{ border: "0px", padding: "0px", height: "30px" }}
            >
              <button
                type="button"
                class="btn-close"
                style={{ position: "relative", top: "8px", left: "-17px" }}
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>

            <div className="modal-header mod-line d-none pt-0"></div>
            <div className="modal-body">
              <div className="row gy-3 mt-1">

                <h4
                  style={{
                    marginTop: "0px",
                    color: `#0cb744`,
                    cursor: "pointer",
                    textAlign: "center",
                    fontSize: "21px",
                    fontWeight: "800",
                  }}
                >
                  Voucher Info
                </h4>
                <p
                  className="ccedit-p "
                  style={{ textAlign: "left", fontSize: "13px" }}
                >

                  <ul style={{ listStyleType: "disc", fontSize: '14px', padding: '0px 10px' }}>
                    {voucherdesc ? voucherdesc.map((item, index) => (
                      <li style={{ padding: '4px 0px', display: 'list-item' }}>{item}</li>
                    )) : ''}
                  </ul>

                </p>
              </div>
            </div>
          </div>
        </div>
      </div>


      {/* pop box start here  */}


      <div style={{
        overflow: "hidden",
        width: "5%",
        position: "relative",
      }}
      >
        <button
          ref={openalert}
          type="button"
          style={{
            fontSize: "12px",
            position: "absolute",
            left: "400px",
          }}
          data-bs-toggle="modal"
          data-bs-target="#vouchererrorpop"
          class="dropdown-item"
        >
        </button>
      </div>

      <div
        className="modal fade"
        id="vouchererrorpop"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div
          className="modal-dialog modal-dialog-centered"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "end",
          }}
        >
          <div className="modal-content centercontentofalert" style={{ backgroundColor: `#${bgColor}` }}>
            <div className="modal-header mod-line d-none"></div>
            <div className="modal-body" style={{ padding: "0px" }}>
              <div className="row">
                <p
                  className="ccedit-p "
                  style={{
                    textAlign: "center",
                    fontSize: "12px",
                    backgroundColor: `#${bgColor}`,
                    color: "white",
                    fontWeight: "550",
                  }}
                >
                  {vouchererror}
                </p>
              </div>
            </div>
            <div
              className="modal-footer mod-line m-auto"
              style={{
                border: "none",
                position: "absolute",
                left: "389px",
              }}
            >
        
              <button
                type="button"
                className="btn closebtn "
                style={{
                  paddingRight: "20px",
                  fontSize: "12px",
                  fontWeight: "600",
                  color: "#230BB3",
                }}
                data-bs-dismiss="modal"
                aria-label="Close"
                ref={closeref}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* pop end here  */}

    </div>
  )
}

export default VoucherSection